import { render, staticRenderFns } from "./m-block-barcode-scanner.vue?vue&type=template&id=36f9b8f6&scoped=true&lang=pug&"
import script from "./m-block-barcode-scanner.vue?vue&type=script&lang=js&"
export * from "./m-block-barcode-scanner.vue?vue&type=script&lang=js&"
import style0 from "./m-block-barcode-scanner.vue?vue&type=style&index=0&id=36f9b8f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f9b8f6",
  null
  
)

export default component.exports